<template>
    <div class="carousel">
        <div class="carousel__header">
            <p class="carousel__title">Testimonials</p>
            <div class="carousel__buttons">
                <button
                    class="button__carouselleft"
                    @click="$refs.myVueperSlides.previous()"
                ></button>
                <button
                    class="button__carouselright"
                    @click="$refs.myVueperSlides.next()"
                ></button>
            </div>
        </div>
        <vueper-slides
            fixed-height="620px"
            class="no-shadow"
            ref="myVueperSlides"
            :arrows="false"
            autoplay
        >
            <vueper-slide
                v-for="(slide, i) in getTestimonials"
                :key="i"
                :title="
                    '<b>' +
                        slide.customer_name +
                        '</b></br>' +
                        slide.customer_business
                "
                :content="slide.testimonial"
            />
        </vueper-slides>
    </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { mapGetters } from "vuex";

export default {
    components: { VueperSlides, VueperSlide },
    data() {
        return {};
    },
    computed: {
        ...mapGetters(["getTestimonials"])
    }
};
</script>
<style scoped></style>
